import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { INDEX, SETTINGS, LOGIN, SCAN, ITEM, EXPORT, HISTORY, CENSUS, WAREHOUSE, VISITOR } from "router";
import { HomePage, ErrorPage, App } from "domain/App";
import { LoginPage } from "domain/Authentication";
import { InventoryPage, ScanPage } from "domain/Inventory";
import { SettingsPage } from "domain/Settings";
import { ExportPage } from "domain/Export";
import { HistoryPage } from "domain/History";
import { useAuthentication } from "../domain/Authentication/context/index";
import { CensusList } from "../domain/Census";
import { CensusDetails } from "../domain/Census";
import { ScanPageProvider } from "domain/Inventory/context/scan-page.provider";
import { HomePageProvider } from "domain/App/pages/context/home-page.provider";
import { SharedListsProvider } from "domain/App/pages/context/shared-lists.provider";
import { InventoryPageProvider } from "domain/Inventory/context/inventory-page.provider";
import { SettingsPageProvider } from "domain/Settings/context/settings-page.provider";
import { ExportPageProvider } from "domain/Export/context/export-page.provider";
import { HistoryPageProvider } from "domain/History/context/history-page.provider";
import { CensusListProvider } from "domain/Census/context/census-list.provider";
import { CensusDetailsProvider } from "domain/Census/context/census-details.provider";
import { WarehousePage } from "domain/Warehouse/pages";
import { WarehousePageProvider } from "domain/Warehouse/context/warehouse-page.provider";
import { VisitorDashboard } from "../domain/Visitor/pages/visitor-dashboard/visitor-dashboard.page";

export const GlobalRouter = () => {
  const { isPrivileged, isVisitor } = useAuthentication();
  return (
    <BrowserRouter>
      <Routes>
        <Route path={LOGIN} element={<LoginPage />} />
        <Route path={INDEX} element={<App />}>
          <Route path={SCAN}>
            <Route
              path=":id"
              element={
                <ScanPageProvider>
                  <ScanPage />
                </ScanPageProvider>
              }
            />
          </Route>
          {isVisitor && <Route index element={<VisitorDashboard />} />}
          {isPrivileged && (
            <>
              <Route element={<SharedListsProvider />}>
                <Route
                  index
                  element={
                    <HomePageProvider>
                      <HomePage />
                    </HomePageProvider>
                  }
                />
                <Route path={ITEM}>
                  <Route
                    path=":id"
                    element={
                      <InventoryPageProvider>
                        <InventoryPage />
                      </InventoryPageProvider>
                    }
                  />
                </Route>
              </Route>
              <Route
                path={SETTINGS}
                element={
                  <SettingsPageProvider>
                    <SettingsPage />
                  </SettingsPageProvider>
                }
              />
              <Route
                path={EXPORT}
                element={
                  <ExportPageProvider>
                    <ExportPage />
                  </ExportPageProvider>
                }
              />
              <Route
                path={HISTORY}
                element={
                  <HistoryPageProvider>
                    <HistoryPage />
                  </HistoryPageProvider>
                }
              />
              <Route
                path={WAREHOUSE}
                element={
                  <WarehousePageProvider>
                    <WarehousePage />
                  </WarehousePageProvider>
                }
              />
              <Route
                path={CENSUS}
                element={
                  <CensusListProvider>
                    <CensusList />
                  </CensusListProvider>
                }
              ></Route>
              <Route
                path="census/:id"
                element={
                  <CensusDetailsProvider>
                    <CensusDetails />
                  </CensusDetailsProvider>
                }
              />
              <Route path={VISITOR} element={<VisitorDashboard />} />
            </>
          )}
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
};
